import React from 'react';
import {observable, action, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';
import {Portal} from '../../../util';
import {ICoord} from '../../i';

// Control arm only: the redesign's cart step shows the product page's recommendations instead (ab-redesign-recommend.tsx).
@observer
export default class Coord extends React.Component {
    @observable loading: boolean = false;

    constructor(props) {
        super(props);
        this.getCoordproducts = this.getCoordproducts.bind(this);
        this.getCoordinated = this.getCoordinated.bind(this);
        makeObservable(this);
    }

    componentDidMount() {
        setTimeout(() => this.getCoordinated(), 300);
    }

    @action getCoordinated = async () => {
        if (store.uiCheckout.loadingCoord || store.uiCheckout.coord.length >= 2) {
            return;
        }
        store.uiCheckout.loadingCoord = true;
        const arr: ICoord[] = [];

        store.checkout.cart.items.map(
            o =>
                o.MouldingID > 0 &&
                arr.push({
                    img: `${Portal?.IMGDomain}/i/0_200_300_1_${o.MouldingID}_${o.PrimaryMatID < 0 ? 337 : o.PrimaryMatID}_${o.SecondaryMatID < 0 ? 0 : o.SecondaryMatID}_0_4_1088_0___0____0__11.000_0_8.500_0_0_0_0.png`,
                    // return $"{pid}_{w}_{h}_{dyfid}_{m0}_{m1}_{m2}_{i}_{d}_{e}_{l}_{lc}_{ln}_{e0}_{e1}_{e2}_{e3}_{vbgid}_{vbg}_{w1}_{w2}_{h1}_{h2}_{o}_{c}_{x}";
                    url: `/frame-designer?fs=1&sdm=1&mmid=${o.MouldingID}&pmid=${o.PrimaryMatID < 0 ? 337 : o.PrimaryMatID}&smid=${o.SecondaryMatID < 0 ? 385 : o.SecondaryMatID}&ish=1`,
                    cls: '',
                    title: 'Create a Matching Certificate Frame',
                    desc: '',
                    CoordProductID: o.productId,
                }),
        );

        store.checkout.cart.items.map(o => {
            if (o.SecondaryMatID !== 385 && o.SecondaryMatID !== 398 && o.MouldingID > 0) {
                arr.push({
                    img: `${Portal?.IMGDomain}/i/0_200_300_1_${o.MouldingID}_${o.SecondaryMatID < 0 ? 337 : o.SecondaryMatID}_${o.PrimaryMatID < 0 ? 0 : o.PrimaryMatID}_0_4_1088_0___0____0__11.000_0_8.500_0_0_0_0.png`,
                    url: `/frame-designer?fs=1&sdm=1&mmid=${o.MouldingID}&pmid=${o.SecondaryMatID < 0 ? 337 : o.SecondaryMatID}&smid=${o.PrimaryMatID < 0 ? 385 : o.PrimaryMatID}&ish=1`,
                    cls: '',
                    title: 'CREATE A COORDINATING CERTIFICATE FRAME',
                    desc: '',
                    CoordProductID: o.productId,
                });
            }
        });

        store.checkout.cart.items.map(o => {
            if (o.IsDYF) {
                arr.push({
                    img: `${Portal?.IMGDomain}/i/0_200_300_1_${o.MouldingID}_${o.SecondaryMatID < 0 ? 337 : o.SecondaryMatID}_${o.PrimaryMatID < 0 ? 0 : o.PrimaryMatID}_0_4_1088_0___0____0__11.000_0_8.500_0_0_0_0.png`,
                    url: `/frame-designer?fs=10&sdm=1&mmid=${o.MouldingID}&pmid=${o.SecondaryMatID < 0 ? 337 : o.SecondaryMatID}&smid=${o.PrimaryMatID < 0 ? 385 : o.PrimaryMatID}&ish=1`,
                    cls: '',
                    title: 'CUSTOMIZE A PHOTO FRAME WITH YOUR GRAD YEAR',
                    desc: '',
                    CoordProductID: o.productId,
                });
            }
        });
        const arr2 = await this.getCoordproducts();

        runInAction(() => {
            // approved ria
            store.uiCheckout.coord = [...arr2, ...arr];
            store.uiCheckout.loadingCoord = false;
        });
    };

    @action getCoordproducts = async () => {
        const arr: ICoord[] = [];
        const success = await checkout('coord');
        try {
            const _payload: [] = JSON.parse(store.checkout.messages[0].msg);
            if (_payload != undefined && _payload.length > 0) {
                _payload.map((o: any) =>
                    arr.push({
                        img: (() => {
                            return o.Product_Image_Thumb.Includes('https') ? o.Product_Image_Thumb : `https://${Portal?.CDNDomain}/images/products/thumb/${o.Product_Image_Thumb}`;
                        })(),
                        url: o.URL,
                        cls: '',
                        title: o.Name,
                        desc: '',
                        CoordProductID: o.CoordProductID,
                    }),
                );
            }
        } catch {
            return arr;
        }
        return arr;
    };

    render() {
        if (store.checkout.isMyFrames) {
            return <div></div>;
        }

        return (
            <div className="coord">
                {store.uiCheckout.coord != undefined && store.uiCheckout.coord.length > 0 && (
                    <div style={{marginTop: 40}}>
                        <div
                            className="form-label form-label-light"
                            style={{fontSize: 16, fontWeight: 700}}
                        >
                            WE THOUGHT YOU MIGHT ALSO LIKE
                        </div>
                        <div
                            className="coord-prod"
                            style={{
                                overflowX: store.uiCheckout.coord.length > 4 ? 'scroll' : 'hidden',
                            }}
                        >
                            {store.uiCheckout.coord.map((o, i) => (
                                <div key={i}>
                                    <a
                                        href={o.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={o.cls === '' ? '' : `${o.cls}`}
                                        aria-label={`View related product #${(i + 1).toString()}`}
                                    >
                                        <img
                                            loading="lazy"
                                            src={o.img}
                                            alt=""
                                            width={188}
                                            height={125}
                                        />
                                    </a>
                                    <div className="form-label coord-label form-label-light pad-top">{o.title}</div>
                                    <div>{o.desc}</div>
                                    <div>
                                        <div
                                            className="yotpo"
                                            data-appkey="H8vQ6ytRf3Uo0eAAlJJh85FR61IeET7EXRvzKasQ"
                                            data-domain="https://www.diplomaframe.com"
                                            data-product-id={o.CoordProductID}
                                            data-name={o.title}
                                            data-url={o.url}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
